"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultProfilerActivator = void 0;
const profilerVars = ['EXPO_PROFILER', 'REACT_NATIVE_PROFILER', 'REACT_APP_PROFILER', 'PROFILER'];
const extractFromEvn = () => {
    if (process && process.env) {
        return Object.keys(process.env).findIndex((i) => profilerVars.includes(i)) !== -1;
    }
    return false;
};
let active = extractFromEvn();
exports.DefaultProfilerActivator = {
    isActive: () => active,
    setActive: (status) => {
        active = typeof status === 'boolean' ? status : extractFromEvn();
        return active;
    },
};
//# sourceMappingURL=DefaultProfilerActivator.js.map